<template>
    <q-menu
        transition-show="scale"
        transition-hide="scale"
        @update:model-value="updateSelectedOption"
    >
        <q-list style="min-width: 100px">
            <q-item v-for="(option, index) in options" :key="index" v-close-popup clickable>
                <slot :option="option" />
            </q-item>
        </q-list>
    </q-menu>
</template>

<script setup>
import { ref } from 'vue'

defineProps({
    options: Array,
})

const selectedOption = ref()

function updateSelectedOption(value) {
    selectedOption.value = value
}
</script>
